import { entryArtistIds, entryInterestIds } from '@shared/lineupActs'
import { setLabel } from '../../../lib/setLabel'
import type { Artist, LineupEntry } from '../../../types'

/** Crew who hearted any artist of the act here — a performer or the collab it plays as. */
export function actUserIds(entry: LineupEntry, artistUserIds: Record<string, string[]>): string[] {
  return [...new Set(entryInterestIds(entry).flatMap(id => artistUserIds[id] ?? []))]
}

/** The viewer hearted the act when they hearted any of its artists for this event. */
export function isActFollowed(entry: LineupEntry, interestedArtistIds: ReadonlySet<string>): boolean {
  return entryInterestIds(entry).some(id => interestedArtistIds.has(id))
}

/** Any of the act's artists is followed app-wide but not hearted here — the card's rose-outlined heart. */
export function isActFollowHinted(entry: LineupEntry, followHintIds: ReadonlySet<string>): boolean {
  return entryInterestIds(entry).some(id => followHintIds.has(id))
}

/**
 * How an act card is named: `name`/`tagline` from setLabel, plus the billing
 * the name line leads with when it isn't just the performers ("Skull Machine",
 * "Fury with MC Dino") — SetNameContent shows that instead of "A b2b B".
 */
export function actCardLabel(entry: LineupEntry, artists: Record<string, Artist>) {
  const { name, title } = setLabel(entry, artists)
  const joined = entryArtistIds(entry).map(id => artists[id]?.name ?? id).join(' b2b ')
  return { name, tagline: title, leadTitle: name !== joined ? name : undefined }
}
